import { FC, PropsWithChildren } from "react";

const PageContainerWrapper: FC<PropsWithChildren> = ({ children }) => {
  return <div className="page-structure-container">{children}</div>;
};

export default PageContainerWrapper;
